import React from 'react'
import 'react-multi-carousel/lib/styles.css'
import Carousel from 'react-multi-carousel'
import { EmployeeItem } from './styles/AboutUsStyles'

export const AboutUsSlider = () => {

    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
    };

    return (
        <Carousel responsive={responsive} pauseOnHover={true} arrows={false} infinite={true} showDots={true} autoPlaySpeed={7000} itemClass="carousel-about-us" autoPlay={false}>
            <EmployeeItem>
                <img src="./img/employee/employee1.png" className="employee_image" alt="employee 1" />
                <div>
                    <div className="min-ttl">Трипуз Иван</div>
                    <div className="subtitle fs-n">ФКСИС - ПОИТ, 2 курс</div>
                    <div className="subtitle fs-n">Back-End</div>
                </div>
            </EmployeeItem>
            <EmployeeItem>
                <img src="./img/employee/employee2.png" className="employee_image" alt="employee 2" />
                <div>
                    <div className="min-ttl">Марьин Александр</div>
                    <div className="subtitle fs-n">ФКСИС - ПОИТ, 2 курс</div>
                    <div className="subtitle fs-n">Back-End</div>
                </div>
            </EmployeeItem>
            <EmployeeItem>
                <img src="./img/employee/employee3.png" className="employee_image" alt="employee 3" />
                <div>
                    <div className="min-ttl">Сайдалихуджаев Сайдулло</div>
                    <div className="subtitle fs-n">ФКСИС - ПОИТ, 1 курс</div>
                    <div className="subtitle fs-n">Front-End</div>
                </div>
            </EmployeeItem>
            <EmployeeItem>
                <img src="./img/employee/employee4.png" className="employee_image" alt="employee 1" />
                <div>
                    <div className="min-ttl">Станкевич Елена</div>
                    <div className="subtitle fs-n">ФКСИС - ПОИТ, 2 курс</div>
                    <div className="subtitle fs-n">Back-End</div>
                </div>
            </EmployeeItem>
            <EmployeeItem>
                <img src="./img/employee/employee5.png" className="employee_image" alt="employee 1" />
                <div>
                    <div className="min-ttl">Арбузов Глеб</div>
                    <div className="subtitle fs-n">ФИТУ - *, 2 курс</div>
                    <div className="subtitle fs-n">Back-End</div>
                </div>
            </EmployeeItem>
        </Carousel>
    )
}


